import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FabricanteService {
  private url_grupo_2e: string = environment.g2e_api;

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8',
      'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
    }),
  }

  constructor(private http: HttpClient) { }

  public async post(data: any): Promise<any> {
    return await this.http
      .post<any>(`${this.url_grupo_2e}fabricante`, data, this.httpOptions)
      .pipe(
        map((response: any) => response.data),
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }

  public async get(): Promise<Array<any>> {
    return await this.http
      .get<any>(`${this.url_grupo_2e}fabricante`, this.httpOptions)
      .pipe(
        map((response: any) => response.data),
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }

  public async getOne(id: number): Promise<any> {
    return await this.http
      .get<any>(`${this.url_grupo_2e}fabricante/${id}`, this.httpOptions)
      .pipe(
        map((response: any) => response.data),
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }

  public async patch(data: any, id: number): Promise<any> {
    return await this.http
      .patch<any>(`${this.url_grupo_2e}fabricante/${id}`, data, this.httpOptions)
      .pipe(
        map((response: any) => response.data),
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }

  public async delete(id: number): Promise<any> {
    return await this.http
      .delete<any>(`${this.url_grupo_2e}fabricante/${id}`, this.httpOptions)
      .pipe(
        map((response: any) => response.data),
        catchError((error) => throwError(() => error))
      )
      .toPromise();
  }
}
